import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { MdLightMode, MdDarkMode } from 'react-icons/md';
import style from './ThemeToggle.module.css';

const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <button 
      className={style.themeToggle} 
      onClick={toggleTheme}
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDarkMode ? (
        <MdLightMode className={style.themeIcon} />
      ) : (
        <MdDarkMode className={style.themeIcon} />
      )}
    </button>
  );
};

export default ThemeToggle; 